import { useAccount } from "wagmi";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useAuthStore } from "@/stores/auth";
import { useSiwe } from "@/hooks/useSiwe";

/** Renders children when a wallet is connected and the user has a valid JWT. */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { address, isConnected } = useAccount();
  const isAuthed = useAuthStore((s) => s.isAuthed());
  const { perform, loading } = useSiwe();

  if (!isConnected) {
    return (
      <div className="mx-auto max-w-md text-center">
        <div className="card">
          <h2 className="mb-2 text-lg font-semibold">Connect your wallet</h2>
          <p className="mb-4 text-sm text-muted-foreground">
            You need a wallet connection to use this page.
          </p>
          <div className="flex justify-center">
            <ConnectButton />
          </div>
        </div>
      </div>
    );
  }
  if (!isAuthed) {
    return (
      <div className="mx-auto max-w-md text-center">
        <div className="card">
          <h2 className="mb-2 text-lg font-semibold">Sign in with Ethereum</h2>
          <p className="mb-4 text-sm text-muted-foreground">
            Signing is free — no transaction is sent. We use it to prove you control {address}.
          </p>
          <button
            type="button"
            className="btn-primary w-full"
            disabled={loading}
            onClick={() => {
              void perform().catch((err) => console.error(err));
            }}
          >
            {loading ? "Waiting for signature…" : "Sign in"}
          </button>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}
